import { TriangleAlert } from "lucide-react"

/**
 * Stands in for a finding whose card failed to render.
 *
 * A review is read one finding at a time, so one malformed record should cost
 * the reviewer that record — not the rail, the document and the rest of the
 * list. The rule id is shown because it is what someone reports when they ask
 * why a finding will not open.
 */
export function FindingErrorCard({
  ruleId,
  error,
}: {
  ruleId: string
  /** Shown in development only — in production this is an internal detail. */
  error?: Error | null
}): JSX.Element {
  return (
    <li
      role="alert"
      className="rounded-[10px] border border-dashed border-err/40 bg-err-tint/40 px-3 py-2.5"
    >
      <p className="flex min-w-0 items-center gap-1.5 text-body-sm text-text">
        <TriangleAlert className="size-3.5 shrink-0 text-err" aria-hidden="true" />
        <span className="truncate font-id font-semibold">{ruleId}</span>
        <span className="shrink-0 text-text-2">could not be displayed</span>
      </p>
      <p className="mt-1 text-caption leading-normal text-text-3">
        The rest of this review is unaffected. Reload to try again, and report the rule id above if
        it persists.
      </p>
      {import.meta.env.DEV && error && (
        <p className="mt-1.5 font-id text-[10.5px] leading-normal text-err">{error.message}</p>
      )}
    </li>
  )
}
